import * as React from 'react';
import { GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';

type GridToolbarProps = React.ComponentProps<typeof GridToolbar>;

export default function BaseToolbar({
  children,
  ...toolbarProps
}: GridToolbarProps & { children?: React.ReactNode }) {
  return (
    <GridToolbarContainer>
      <GridToolbar {...toolbarProps} />
      {children}
    </GridToolbarContainer>
  );
}